import 'js-loading-overlay';

JsLoadingOverlay.setOptions({
    overlayBackgroundColor: '#666666',
    overlayOpacity: 0.6,
    spinnerIcon: 'ball-spin-clockwise',
    spinnerColor: '#000',
    spinnerSize: '2x',
    overlayIDName: 'overlay',
    spinnerIDName: 'spinner',
    offsetY: 0,
    offsetX: 0,
    lockScroll: false,
    containerID: null
});

export default JsLoadingOverlay